import { Box } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';
import dayjs from 'dayjs';
import './chart.css';
import { colors } from '../Theme/tokens';

const EmptyChart = () => {
  const [graphData, setGraphData] = useState({});

  const getLastSixMonths = () => {
    const months = [];
    for (let i = 5; i >= 0; i--) {
      months.push(dayjs().subtract(i, 'month').format('MMM YY'));
    }
    return months;
  };

  useEffect(() => {
    const defaultChartData = {
      options: {
        chart: {
          type: 'area',
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          labels: {
            style: {
              fontWeight: '600',
              colors: colors.text.primary,
              paddingRight:"20px"
            },
            formatter: function (value) {
              return '$' + Math.round(value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
            },
          },
          min: 5000,
          max: 30000,
          tickAmount: 3,
        },
        xaxis: {
          type: 'category',
          tickAmount:3,
          categories: getLastSixMonths(), // Dynamically generated last 6 months
          labels: {
            style: {
              fontWeight: '600',
              colors: colors.text.primary,
              paddingLeft:'20px',
            },
            offsetX: 0, // Adjust X offset if needed
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        colors: [colors.primary.main],
        fill: {
          type: 'gradient',
          colors: [colors.primary.main],
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 90, 100],
          },
        },
        stroke: {
          width: 2,
          curve: 'stepline',
        },
        tooltip: {
          enabled: false, // Disable tooltip since there's no data
        },
      },
      series: [
        {
          data: [null, null, null, null, null, null], // Placeholder data for X-axis to show
        },
      ],
    };
    setGraphData(defaultChartData);
  }, []);

  return (
    <Box component='div' width='100%' sx={{ padding: '32px' }} className="apexcharts-xaxis-texts-g custom-xaxis-shift">
      {graphData?.options?.chart && (
        <Chart options={graphData?.options} series={graphData?.series} type="area" width="100%" height='400px' />
      )}
    </Box>
  );
};

export default EmptyChart;
